<template>
  <div class="location">
    <DpplTooltip
      tooltip-placement="left"
      :tooltip-offset="12"
    >
      <template #activator="{ onMouseenter, onMouseleave }">
        <p
          @mouseenter="onMouseenter"
          @mouseleave="onMouseleave"
        >
          {{ location }}
        </p>
      </template>
      <template #tooltip-content>
        <p class="content">
          {{ location }}
        </p>
      </template>
    </DpplTooltip>
  </div>
</template>

<script setup>
import DpplTooltip from '@/components/datapeople/DpplTooltip.vue';

defineProps({
  location: {
    type: String,
    default: '',
  },
});
</script>

<style lang="less" scoped>
.location {
  max-width: 100%;
  overflow: hidden;

  :deep(p) {
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    font-weight: 500;
    font-size: 13px;
    line-height: normal;
    color: rgb(var(--v-theme-textLight));

    &.content {
      line-height: 150%;
      color: rgb(var(--v-theme-textLight));
      overflow: visible;
      white-space: normal;
    }
  }
}
</style>
